
import * as PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4 from './androidx-collection-collection-wasm-js.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI_ from './kotlinx-browser.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4 from './kotlinx-coroutines-coreWasm.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4__ALL_EXPORTS } from './androidx-collection-collection-wasm-js.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS } from './kotlinx-browser.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS } from './kotlinx-coroutines-coreWasm.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<androidx.collection:collection>': PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-coroutines-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-browser>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS,
};
    